"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Table = _interopRequireDefault(require("../../preact-components/table/Table"));

var _Loader = require("./Loader");

var _EmptyTable = _interopRequireDefault(require("./EmptyTable"));

var _EmptyResults = require("./EmptyResults");

var _searchAnalyticsTransformer = require("./searchAnalyticsTransformer");

var _TableTitle = _interopRequireDefault(require("./TableTitle"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Tooltip description for the Top Searches table
 */
var TOP_SEARCHES_TOOLTIP = 'The most frequently searched queries during the selected time period.';

var TopSearchesTable = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopSearchesTable, _Component);

  var _super = _createSuper(TopSearchesTable);

  function TopSearchesTable() {
    var _this;

    (0, _classCallCheck2.default)(this, TopSearchesTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      topSearches: [],
      isLoading: true
    });
    return _this;
  }

  (0, _createClass2.default)(TopSearchesTable, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(prevProps) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.props.startDate !== prevProps.startDate || this.props.endDate !== prevProps.endDate)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.fetchTopSearches();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "fetchTopSearches",
    value: function () {
      var _fetchTopSearches = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this$props$apiUrl, _res$data, _url, res, data;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  isLoading: true
                });
                _context2.prev = 1;
                _url = (_this$props$apiUrl = this.props.apiUrl) !== null && _this$props$apiUrl !== void 0 ? _this$props$apiUrl : '/analyticsV2/searchAnalyticsKeyInsights';
                _context2.next = 5;
                return this.props.fetchData(_url, '', {}, 'top_searches');

              case 5:
                res = _context2.sent;
                // Use transformer to handle both Legacy and Data Lake response formats
                data = (0, _searchAnalyticsTransformer.transformTopSearches)((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data);
                this.setState({
                  topSearches: data,
                  isLoading: false
                });
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](1);
                this.setState({
                  isLoading: false
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 10]]);
      }));

      function fetchTopSearches() {
        return _fetchTopSearches.apply(this, arguments);
      }

      return fetchTopSearches;
    }()
    /**
     * Renders the table title with tooltip
     */
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: "renderTitle",
    value: function renderTitle() {
      return (0, _preact.h)(_TableTitle.default, {
        title: "Top searches",
        tooltipMessage: TOP_SEARCHES_TOOLTIP,
        className: "title-top_searches__table"
      });
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "getModel",
    value: function getModel() {
      return [{
        header: 'Query',
        accessor: 'search',
        size: 'm'
      }, {
        header: 'Count',
        accessor: 'count',
        size: 's'
      }];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          topSearches = _this$state.topSearches,
          isLoading = _this$state.isLoading;
      var table = (0, _preact.h)(_EmptyTable.default, {
        model: this.getModel(),
        actionElements: this.renderTitle()
      }, (0, _preact.h)(_Loader.Loader, {
        parentCustomClass: "dashboard-table-loader"
      }));

      if (!isLoading) {
        table = topSearches.length > 0 ? (0, _preact.h)(_Table.default, {
          model: this.getModel(),
          rows: topSearches,
          classes: ['top_searches__table'],
          actionElements: this.renderTitle()
        }) : (0, _preact.h)(_EmptyTable.default, {
          model: this.getModel(),
          actionElements: this.renderTitle()
        }, (0, _preact.h)(_EmptyResults.EmptyResults, null));
      }

      return (0, _preact.h)("div", {
        className: "dashboard-table-wrapper"
      }, table);
    }
  }]);
  return TopSearchesTable;
}(_preact.Component);

var _default = TopSearchesTable;
exports.default = _default;